import "../styles/main.css";
import 'font-awesome/css/font-awesome.css';

import { useState } from 'react';
import { Routes, Route } from 'react-router-dom';

import { EU_COUNTRY_CODES } from "../codes";
import Navigation from "../components/Navigation";
import Footer from "../components/Footer";
import { Storage } from "../tools";
import { IndexMetaInfo } from "../MetaInfo";
import SearchView from "./SearchView";
import AboutView from "./AboutView";
import IndexView from "./IndexView";
import NotFound from "./NotFound";


function CookiesBanner({ country }) {
    const [hide, setHide] = useState(
        EU_COUNTRY_CODES.indexOf(country) === -1 || Storage.getObject("cookiesEU")
    );

    if (hide) return null;

    const onClick = () => {
        Storage.setItem("cookiesEU", true);
        setHide(true);
    };

    return (
        <div className="Cookies">
            <p>
                This website uses cookies.
                By continuing to browse the site you are agreeing to use of cookies.
                For more details about cookies use check our
                <a href="/privacy">privacy policy</a>
            </p>
            <button onClick={onClick} className="button hollow yellow">
                <span>ok</span>
            </button>
        </div>
    );
}


export default function App() {
    return (
        <>
            <IndexMetaInfo />
            <Navigation />

            <Routes>
                <Route path="/" element={<IndexView />} />
                <Route path="/search/:lat/:lng/:zoom" element={<SearchView />} />
                <Route path="/s/:id" element={<SearchView />} />
                <Route path="/about" element={<AboutView />} />
                <Route path="*" element={<NotFound />} />
            </Routes>

            <Footer />

            <CookiesBanner country="PL" />
        </>
    );
}
